import Card from '@/components/card';
import FormSection from '@/components/form/form-section';
import { FormHandle } from '@/hooks/use-form-handle.hook';
import { PolicyModel } from '@/lib/models/policy-model/policy.model';
import { FC, useMemo } from 'react';
import { ContentControlSettings } from '@/lib/models/policy-model/content-controls';
import ContentControlItem from './item';
import FormSectionSubtitle from '@/components/form/form-section/form-section-subtitle';

interface Props {
  policy: PolicyModel;
  formHandle: FormHandle<PolicyModel>;
  readonly: boolean;
  defaultPolicy?: PolicyModel;
  withNotSet?: boolean;
}

const ContentControls: FC<Props> = ({
  formHandle,
  readonly,
  policy,
  defaultPolicy,
  withNotSet = true,
}) => {
  // File uploads is managed in the service access tab
  const availableControls = useMemo(() => {
    return ContentControlSettings.filter(({ type }) => type !== 'file-upload');
  }, []);

  return (
    <FormSection title="Content Controls" scrollId="content-controls">
      <FormSectionSubtitle>
        For each content type below, choose the action to take when that type is detected in the
        request.
      </FormSectionSubtitle>
      <Card>
        {availableControls.map(({ type: settingType }) => {
          return (
            <ContentControlItem
              key={`content-control-${settingType}`}
              controlType={settingType}
              formHandle={formHandle}
              readonly={readonly}
              policy={policy}
              defaultPolicy={defaultPolicy}
              withNotSet={withNotSet}
            />
          );
        })}
      </Card>
    </FormSection>
  );
};

export default ContentControls;
